/**
 * The frontend will create livecontroller when we go through our own php code and host the content it self ( the old way )
 * @creator Stefano
 * @date 26-6-2018
 */
export default class SharedController {
    constructor() {}
}
